// Match all non-numeric characters
export const NON_NUMERIC_REGEX = /[^0-9]/g;

// Match commas and spaces
export const NAME_EMAIL_SPLIT_REGEX = /[, ]+/;

// Match carets
export const REMOVE_CARETS_REGEX = /[<>]/g;

// Match name and email format (e.g. "John Doe <john@doe.com>")
export const NAME_EMAIL_MATCH_REGEX = /^(.+) <(.+)>$/;

export const COMMENT_MENTION_EMAIL_REGEX =
  /\+[a-zA-Z0-9+_.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9.-]+/g;

// Match @mention email format (e.g. "+jon@doe.com")
export const MENTION_EMAIL_REGEX = /^\+/g;

// Match periods at the end of strings
export const REMOVE_PERIODS_REGEX = /\.$/;

// Matches timestamps enclosed in angle brackets, including decimal numbers (e.g. "<123.45>")
export const TIMESTAMP_REGEX = /<\d+(\.\d+)?>/;

// Matches meeting engagement markers enclosed in angle brackets (e.g. "<M1>")
export const MEETING_ENGAGEMENT_REGEX = /<M\d+(\.\d+)?(\+\d+)?>/;

// Matches email engagement markers enclosed in angle brackets (e.g. "<E1>")
export const EMAIL_ENGAGEMENT_REGEX = /<E\d+(\.\d+)?>/;

// Matches invalid citation markers (i.e. does not contain any numbers) enclosed in angle brackets (e.g. "<Deal Metadata>")
export const INVALID_CITATION_REGEX =
  /^<(?!\d+(\.\d+)?$|M\d+(\.\d+)?(\+\d+)?$|E\d+(\.\d+)?$).*?>$/;

// Matches malformed citation remnants that got separated from their parent citation (e.g. "+3512>" from "<M46509>+3512>")
// Uses negative lookbehind to avoid matching inside valid citations like <M46863753+1007>
export const MALFORMED_CITATION_REMNANT_REGEX = /(?<!<M\d+)\+\d+>/g;

// Matches HTML-like tags or custom markers enclosed in angle brackets (e.g. "<div>", "<customTag>")
export const TAG_MARKERS_REGEX = /(<[^>]+>)/g;

// Used to format Copilot markdown to plain text
export const HEADER_SEPARATOR_LINE_REGEX = /^\|\s*\|/gm;
export const HTML_TAGS_REGEX = /<[^>]*>/g;
export const TABLE_CELL_REGEX = /^\|\s*([^|]*)\s*\|/gm;
export const REMAINING_PIPES_REGEX = /\|/g;
export const DASHES_REGEX = /-{2,}/g;
export const BULLET_POINT_REGEX = /^[•\t ]+/gm;
export const DOUBLE_ASTERISKS_REGEX = /\*\*/g;

// Lines of only `-`/`=` (optional spaces) act as setext underlines or HRs in GFM user messages
export const USER_MARKDOWN_DASH_EQUALS_LINE_REGEX = /^[ \t]*[-=]+[ \t]*$/gm;

// Used to insert new lines before Copilot markdown table rows
export const TRIPLE_PIPE_REGEX = /\n\s*(\|\|\|)/g;

// Used to insert newline after Deal Copilot citation
export const DEAL_COPILOT_CITATION_REGEX = />\n/g;
